import * as React from "react";
import PubSub from 'pubsub-js';
import { dialogService } from "react-api-dialog";
import { messageDialog } from "../dialogs/MessageDialog";
import { AuthHeader } from "./AuthHeader";
import { Form, FormRef } from "@ajayvikas/react-fluent-validation";
import { Input } from "../Controls/Input";
import { changePasswordValidator } from "./validators";
import t from "../i18n";
import { MyAccountService } from "../myaccount/myaccount-service";
import { Props } from "../../types/global";
import { AuthService } from "./auth-service";
import classNames from "classnames";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";

declare type ChangePasswordState = {
    email: string,
    currentPassword: string,
    newPassword: string,
    confirmNewPassword: string,
}
export default class ChangePassword extends React.Component<Props, ChangePasswordState> {
    readonly state: ChangePasswordState = {} as ChangePasswordState;
    form: FormRef | null;
    assignFormRef = (form: FormRef | null) => {
        this.form = form;
    }
    showMessage = async (message: string, title: string) => {
        if (this.props.ok) {
            alert(message);
        } else {
            await messageDialog(message, title);
        }
    }
    componentDidMount() {
        AuthService.isLoggedIn().then(response => {
            if (response) this.setState({ email: response });
        });
    }
    onChangePassword = async () => {
        if (!this.form) return;
        const validationResult = this.form.submit();
        const isValid = validationResult?.isValid() ?? false;
        if (isValid === false) {
            this.showMessage(t.error("validation_error"), t.menu("login"));
            return;
        }
        dialogService.showPreloader();
        const response = await MyAccountService.changePassword({
            confirmPassword: this.state.confirmNewPassword,
            newPassword: this.state.newPassword,
            oldPassword: this.state.currentPassword
        });
        await dialogService.hidePreloader();
        if (response.responseCode === 0) {
            await this.showMessage(t.login("password_successfully_changed"), t.login("change_password"));
            this.props.history.push("/home");
        } else {
            this.showMessage(response.responseMessage || "", t.login("change_password"));
        }
    }
    onLoginSuccess = () => {
        PubSub.publish("AUTH", "LOGIN");
        if (this.props.ok) this.props.ok(true);
        else this.props.history.replace("/topup");
    }
    onCancel = () => {
        if (this.props.cancel) this.props.cancel();
        else (this.props.history.goBack())
    }
    render() {
        return (
            <div className="auth container small-gutter">
                <div className="auth-box">
                    <Form ref={this.assignFormRef} object={this.state} validator={changePasswordValidator}>
                        <AuthHeader text={t.menu("change_password")} showLogo={!!this.props.ok} />
                        <div className="form-group relative">
                            <h5>{t.topup("user_name_label")}</h5>
                            <Input type="text" className="form-control" propertyName="email" readOnly={true}
                                value={this.state.email || ""}
                                onChange={e => this.setState({ email: e.target.value })} />
                        </div>
                        <div className="form-group relative">
                            <h5>{t.login("current_password")}</h5>
                            <Input type="password" className="form-control" propertyName="currentPassword"
                                value={this.state.currentPassword || ""}
                                onChange={e => this.setState({ currentPassword: e.target.value })} />
                        </div>
                        <div className="form-group relative">
                            <h5>{t.login("new_password")}</h5>
                            <div style={{ fontSize: 12, marginBottom: 5 }}>{t.validations("password_message")}</div>
                            <Input type="password" className="form-control" propertyName="newPassword"
                                value={this.state.newPassword || ""}
                                onChange={e => this.setState({ newPassword: e.target.value })} />
                        </div>
                        <div className="form-group relative">
                            <h5>{t.login("confirm_new_password")}</h5>
                            <Input type="password" className="form-control" propertyName="confirmNewPassword"
                                value={this.state.confirmNewPassword || ""}
                                onChange={e => this.setState({ confirmNewPassword: e.target.value })} />
                        </div>
                        <div className="form-group text-right">
                            <a className="button white text-center" onClick={this.onCancel}>{t.common("cancel_button")}</a>
                            <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.onChangePassword}>{t.menu("change_password")}</a>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}